import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Section } from "@faire/retailer-visitor-shared/views/careers/__internal__/common/common";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrl } from "@faire/web--source/common/transform-images";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
import styled from "styled-components";
export var BelongingLifeAtFaire = function() {
    var _useViewport = useViewport(), isMobile = _useViewport.isMobile, isTabletAndBelow = _useViewport.isTabletAndBelow;
    var strictLocalize = useStrictLocalization().strictLocalize;
    var bottomSpacing = useResponsiveValue({
        mobileAndAbove: "10x",
        tabletAndAbove: "8x",
        desktopAndAbove: 120
    });
    var isSSR = useIsSSR();
    return /*#__PURE__*/ _jsxs(Section, {
        align: "center",
        children: [
            /*#__PURE__*/ _jsxs(HideOverflowRow, {
                justify: "center",
                children: [
                    /*#__PURE__*/ _jsx("img", {
                        src: optimizeImageUrl({
                            url: OUTDOOR_IMAGE(strictLocalize).url
                        }, isSSR, {
                            width: OUTDOOR_IMAGE(strictLocalize).width,
                            height: OUTDOOR_IMAGE(strictLocalize).height
                        }),
                        style: {
                            width: OUTDOOR_IMAGE(strictLocalize).width,
                            height: OUTDOOR_IMAGE(strictLocalize).height
                        },
                        alt: OUTDOOR_IMAGE(strictLocalize).alt_text
                    }),
                    isMobile ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "2x"
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: optimizeImageUrl({
                                    url: FAIRENT_IMAGE(strictLocalize).url
                                }, isSSR, {
                                    width: FAIRENT_IMAGE(strictLocalize).width,
                                    height: FAIRENT_IMAGE(strictLocalize).height
                                }),
                                style: {
                                    width: FAIRENT_IMAGE(strictLocalize).width,
                                    height: FAIRENT_IMAGE(strictLocalize).height
                                },
                                alt: FAIRENT_IMAGE(strictLocalize).alt_text
                            })
                        ]
                    }),
                    isTabletAndBelow ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Spacer, {
                                height: "2x"
                            }),
                            /*#__PURE__*/ _jsx("img", {
                                src: optimizeImageUrl({
                                    url: GROUP_OFFICE_IMAGE(strictLocalize).url
                                }, isSSR, {
                                    width: GROUP_OFFICE_IMAGE(strictLocalize).width,
                                    height: GROUP_OFFICE_IMAGE(strictLocalize).height
                                }),
                                style: {
                                    width: GROUP_OFFICE_IMAGE(strictLocalize).width,
                                    height: GROUP_OFFICE_IMAGE(strictLocalize).height
                                },
                                alt: GROUP_OFFICE_IMAGE(strictLocalize).alt_text
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "5x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                variant: "sectionHeaderSansMedium",
                align: "center",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "YeKUt5",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Follow us on "
                        },
                        {
                            type: 8,
                            value: "LinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "@lifeatfaire"
                                }
                            ]
                        }
                    ],
                    values: {
                        LinkFormatting: function(chunks) {
                            return /*#__PURE__*/ _jsx(NoUnderlineLink, {
                                linkTo: "https://instagram.com/lifeatfaire",
                                children: chunks
                            });
                        }
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: bottomSpacing
            })
        ]
    });
};
var FAIRENT_IMAGE = function(strictLocalize) {
    return IImage.build({
        url: "https://cdn.faire.com/fastly/7b7543193fc2393fcf46b22fabc4200fc40d428d67ea5f6fa5fe277f1c3edede.png",
        width: 340,
        height: 340,
        alt_text: strictLocalize({
            id: "L2Ck8m",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faire parent with her baby"
                }
            ]
        })
    });
};
var OUTDOOR_IMAGE = function(strictLocalize) {
    return IImage.build({
        url: "https://cdn.faire.com/fastly/3251770535d2f2f35c628a923646b1cf04bfa5c429f1f03f03d6e86b6c5bf38f.png",
        width: 340,
        height: 340,
        alt_text: strictLocalize({
            id: "ialBQI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Faire employee group photo outdoors"
                }
            ]
        })
    });
};
var GROUP_OFFICE_IMAGE = function(strictLocalize) {
    return IImage.build({
        url: "https://cdn.faire.com/fastly/c36a834475ff1e8c89271598bc67c805e44ce9a703bac09d0f9c98686c478149.png",
        width: 340,
        height: 340,
        alt_text: strictLocalize({
            id: "jveBp0",
            defaultMessage: [
                {
                    type: 0,
                    value: "Employee group photo in a Faire office"
                }
            ]
        })
    });
};
var NoUnderlineLink = styled(EmbeddedLink).withConfig({
    componentId: "sc-79bc770a-0"
})([
    "text-decoration:auto;"
]);
var HideOverflowRow = styled(Row).withConfig({
    componentId: "sc-79bc770a-1"
})([
    "overflow:hidden;"
]);
